export const INATIVAR_TITULO = "Inativar cotação";
export const INATIVAR_SUBTITULO = "Essa ação tira a cotação de referência do Outlook.";
export const INATIVAR_CONFIRMAR = "Inativar cotação";
export const INATIVAR_EFEITOS_TITULO = "O que acontece ao inativar";
export const INATIVAR_INTRO = "Você vai inativar esta cotação de referência:";
export const INATIVADA_COM_SUCESSO = "Cotação inativada com sucesso.";

export const SITUACAO_INATIVA = "INATIVA";

/** Ativar não abre modal nem pede justificativa (Figma de 01/11, 5.6): o toast sai direto da linha. */
export const ATIVADA_COM_SUCESSO = "Cotação ativada com sucesso.";
export const ATIVAR_ERRO = "Não foi possível ativar a cotação.";

export const efeitosInativar = (moeda: string, unicaAtiva: boolean) => [
  "O Outlook deixa de usar esta cotação.",
  unicaAtiva
    ? `É a única cotação ativa de ${moeda}: sem ela, o Outlook mostra pendência de cotação de ${moeda} até que outra seja cadastrada ou ativada.`
    : `Se o Outlook ficar sem cotação ativa de ${moeda}, ele mostra uma pendência.`,
  "Os custos e as projeções das Obras não mudam.",
  "Nada é excluído: para usar de novo, clique em ativar na linha.",
];
